import { axios_instance } from "@/api/api";
import FormData from "form-data";

interface BaseBuildRequest {
  version: string;
  description: string;
  fileRc: File;
  fileRcDll: File;
  fileOffice: File;
}

interface BaseBuildResponse {
  data: {
    id: string;
  };
  message: string;
}

export async function createBaseBuild(
  request: BaseBuildRequest,
): Promise<BaseBuildResponse> {
  const data = new FormData();
  data.append("version", request.version);
  data.append("description", request.description);
  data.append("file_rc", request.fileRc);
  data.append("file_rc_dll", request.fileRcDll);
  data.append("file_office", request.fileOffice);

  const config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `/api/v1/view/version/create/base_build`,
    data,
  };

  try {
    const response = await axios_instance.request<BaseBuildResponse>(config);
    return response.data;
  } catch (error) {
    console.error("Failed to create base build:", error);
    throw error;
  }
}

interface BaseBuildPaginationRequest {
  time_from?: number;
  time_to?: number;
  keyword?: string;
  status?: string[];
  page: number;
  size: number;
}

interface PaginationItem {
  id: string;
  version: string;
  description: string;
  // Add other relevant fields from the API response
}

interface BaseBuildFile {
  name: string;
  type: string;
  size: number;
}

interface PaginationItem {
  id: string;
  version: string;
  type: string;
  created: number;
  modified: number;
  description: string;
  md5: string;
  file_name: string;
  base_build: BaseBuildFile[];
}

interface BaseBuildPaginationResponse {
  data: PaginationItem[];
  message: string;
  total_filter: number;
}

export async function getBaseBuildPagination(
  request: BaseBuildPaginationRequest,
): Promise<BaseBuildPaginationResponse> {
  const data = JSON.stringify({
    time_from: request.time_from ?? 0,
    time_to: request.time_to ?? 0,
    keyword: request.keyword ?? "",
    status: request.status ?? [],
    type: ["base_build"],
    page: request.page,
    size: request.size,
  });

  const config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `/api/v1/view/version/pagination`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  try {
    const response =
      await axios_instance.request<BaseBuildPaginationResponse>(config);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch base build pagination:", error);
    throw error;
  }
}
